import { useContext } from 'react'
import { IntakeContext } from '../context/IntakeContext'
import { selectData } from 'layouts/onboarding'
import styled from 'styled-components'
import { Typography } from '@mui/material'

const StyledProfileTile = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 10px;
  padding: 48px;
  border-radius: 40px;
  background: #ffffff;
  width: fit-content;
  margin: 0 auto;
  box-shadow: 0px 8px 50px -16px rgba(0, 0, 0, 0.2);
`

const StyledName = styled(Typography)`
  && {
    font-size: 36px;
    font-weight: 600;
    color: #262627;
    line-height: 1.5;
    white-space: nowrap;
    padding: 0 6px;
  }
`

const StyledRoleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`

const StyledAgencyLogo = styled.img`
  width: 58px;
  height: 44.5px;
  object-fit: contain;
`

const StyledRole = styled(Typography)`
  && {
    font-size: 28px;
    font-weight: 400;
    color: #262627;
    line-height: 1.5;
    white-space: nowrap;
    padding: 0 4px;
  }
`

const UserProfileTile = () => {
  const { intakeState } = useContext(IntakeContext)
  const isGovernmentEmployee = intakeState?.governmentEmployee
  const retiredClient = intakeState?.employmentStatus === 'retired'

  const firstName = intakeState?.firstName || ''
  const lastName = intakeState?.lastName || ''
  const fullName = `${firstName} ${lastName}`.trim()
  
  const agency = intakeState?.agency
  const retirementSystem = intakeState?.retirementSystem
  
  let logo = null
  let label = 'Employee'
  let shortCode = ''
  
  if (agency && isGovernmentEmployee && !retiredClient) {
    // Normal onboarding - show agency
    const agencyData = selectData.agency?.find(
      (a) => a.value === agency
    )
    shortCode = agencyData?.shortcode || ''
    if (agencyData?.logo) {
      logo = agencyData.logo
    }
  } else if (retirementSystem && isGovernmentEmployee) {
    // Speedy onboarding - show retirement system
    const retirementSystemData = selectData.retirementSystem?.find(
      (r) => r.value === retirementSystem
    )

    if (retirementSystemData?.logo) {
      logo = retirementSystemData.logo
    }
  } else if (!isGovernmentEmployee) {
    logo = intakeState?.employerDetails?.logo
    shortCode = intakeState?.employerDetails?.name
  }

  return (
    <StyledProfileTile>
      <StyledName>
        {fullName || 'User'}
      </StyledName>
      {logo ? (
        <StyledRoleContainer>
          <StyledAgencyLogo 
            src={logo} 
            alt="Agency or Retirement System Logo"
            onError={(e) => {
              e.target.style.display = 'none'
            }}
          />
          <StyledRole>
            {`${shortCode} ${label}`}
          </StyledRole>
        </StyledRoleContainer>
      ) : (
        <>
          {shortCode && <StyledRole>
            {`Employer: ${shortCode}`}
          </StyledRole>}
        </>
      )}
    </StyledProfileTile>
  )
}

export default UserProfileTile

